
import { getLogList } from '@/api/admin'
import { delObjEmptyKey } from '@/utils'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import { Component, Vue, Watch } from 'vue-property-decorator'
import pagination from '@/components/Pagination/index.vue'
import { AppModule } from '@/store/modules/app'
import {
  getAntOrderReviewList,
  getAntOrderDetail,
  getAntChangeStatus
} from '@/api/task/antOrderReview'
import List from './components/list.vue'
import Detail from './components/detail.vue'
import { Form as ElForm } from 'element-ui'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue'

const initDate = getCurrentDate()
@Component({
  name: 'antOrderReview',
  components: {
    pagination,
    List,
    Detail,
    ElImageViewer
  }
})
export default class extends Vue {
  private listLoading: boolean = true
  private listQuery = {
    page: 1,
    limit: 20
  }
  private queryForm: any = {
    ant_username: '',
    upstream_ordernumber: '',
    action: '',
    remarks: '',
    min_amount: null,
    max_amount: null,
    start_time: initDate[0],
    end_time: initDate[1]
  }
  private list: any[] = []
  private total = 0
  private pickerOptions = pickerOptions

  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  protected pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }

  private date: any[] = getCurrentDate()

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      await getAntOrderReviewList(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      ant_username: '',
      upstream_ordernumber: '',
      action: '',
      remarks: '',
      min_amount: null,
      max_amount: null
    }
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private dialogVisible: boolean = false
  private openBatchReview(param: any) {
    this.dialogVisible = true
    this.$nextTick(() => {
      const elx: any = this.$refs.list
      elx.onloadAbandonReasonList()
    })
  }

  private batchReviewClose() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
  }

  private drawer: boolean = false
  private currentOrdernumber: any = ''
  private openDrawer(ordernumber: number) {
    this.currentOrdernumber = ordernumber
    this.drawer = true
    this.$nextTick(() => {
      const elx: any = this.$refs.detail
      elx.getDetail()
    })
  }

  private closeDrawer(isManual: boolean = false) {
    this.drawer = false
    this.currentOrdernumber = null
    this.hadleGetFilesListApi()
  }

  private closeAdd() {
    this.dialogVisible = false
    this.drawer = false
    this.hadleGetFilesListApi()
  }

  private setForm: any = {
    status: '',
    order_status: ''
  }
  private rules: any = {
    order_status: [
      {
        required: true,
        message: 'Please select order status',
        trigger: 'change'
      }
    ],
    status: [
      {
        required: true,
        message: 'Please select ant order status',
        trigger: 'change'
      }
    ]
  }
  private changeOrderStatus: boolean = false
  private changeOrderDetail: any = {}
  private openChangeStatus(row) {
    this.changeOrderDetail = row
    this.changeOrderStatus = true
  }
  private closeDialog() {
    this.flagStr()
    this.changeOrderStatus = false
    this.changeOrderReject = false
    this.setForm = {
      status: '',
      order_status: ''
    }
    this.hadleGetFilesListApi()
  }

  private changeOrderReject: boolean = false
  private openRejectOrder(row) {
    this.changeOrderDetail = row
    this.changeOrderReject = true
  }

  private loading: boolean = false
  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 1000)
  }
  private async setOrderStatus() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          let data = {}
          if (this.setForm.status === '5') {
            data = {
              status: this.setForm.status,
              order_status: '2',
              ordernumber: this.changeOrderDetail.ordernumber
            }
          } else if (this.setForm.status === '1') {
            data = {
              status: this.setForm.status,
              order_status: this.setForm.order_status,
              ordernumber: this.changeOrderDetail.ordernumber
            }
          }
          delObjEmptyKey(data)
          await getAntChangeStatus(data).then((res: any) => {
            this.closeDialog()
            this.loading = false
            this.flagStr()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private async setOrderReject() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data = {
            status: '5',
            order_status: this.setForm.order_status,
            ordernumber: this.changeOrderDetail.ordernumber
          }
          delObjEmptyKey(data)
          await getAntChangeStatus(data).then((res: any) => {
            this.closeDialog()
            this.loading = false
            this.flagStr()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  private picture: any = {}
  private pictureBool: boolean = false
  private openPicture(row) {
    this.picture = row
    this.pictureBool = true
  }
  private closePictureDialog() {
    this.pictureBool = false
    this.hadleGetFilesListApi()
  }

  private srcList: any = []
  private examineImg(i) {
    this.pictureBool = true
    this.srcList = i
  }
  private onClose() {
    this.srcList = []
    this.pictureBool = false
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.antOrderReview`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
